export default __webpack_public_path__ + "static/media/montreal.e7b29797.jpg";